export default __webpack_public_path__ + "static/media/wordpress-icon.8cc616bb.png";